import qs from "qs";

export const IMPERSONATION_TOKEN_QUERY_PARAM = "impersonationToken";

const hasBrowserLocation = () =>
  typeof window !== "undefined" && window.location && window.localStorage;

export const isJwtToken = token =>
  typeof token === "string" &&
  token.split(".").length === 3 &&
  token.split(".").every(Boolean);

export const getImpersonationTokenFromSearch = search => {
  const query = qs.parse(search, { ignoreQueryPrefix: true });
  const token = query[IMPERSONATION_TOKEN_QUERY_PARAM];

  return Array.isArray(token) ? token[0] : token;
};

export const removeImpersonationTokenFromSearch = search => {
  const query = qs.parse(search, { ignoreQueryPrefix: true });
  const { [IMPERSONATION_TOKEN_QUERY_PARAM]: _token, ...nextQuery } = query;

  return qs.stringify(nextQuery, { addQueryPrefix: true });
};

export const getCleanImpersonationPath = location => {
  const pathname = location.pathname || "/";
  const search = removeImpersonationTokenFromSearch(location.search);
  const hash = location.hash || "";

  return `${pathname}${search}${hash}`;
};

export const consumeImpersonationToken = () => {
  if (!hasBrowserLocation()) return null;

  const token = getImpersonationTokenFromSearch(window.location.search);
  if (!isJwtToken(token)) return null;

  window.localStorage.setItem("token", token);
  window.localStorage.removeItem("selected_company_id");

  if (window.history && window.history.replaceState) {
    window.history.replaceState(
      window.history.state,
      document.title,
      getCleanImpersonationPath(window.location)
    );
  }

  return token;
};
